// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  threadId: __t.u64().primaryKey().name("thread_id"),
  workspaceId: __t.u64().name("workspace_id"),
  kind: __t.string(),
  title: __t.string(),
  createdBy: __t.string().name("created_by"),
  createdAt: __t.i64().name("created_at"),
});
